import { type SelectOption } from '@aus-platform/design-system';
import { DashboardVolumeType } from 'shared/api';
import { type SupportedFormat } from './types';

export const SUPPORTED_FILE_FORMATS: SupportedFormat[] = [
  {
    category: 'Documents',
    formats: 'CSV, PDF, TXT',
  },
  {
    category: 'Images',
    formats: 'JPG, JPEG, PNG',
  },
  {
    category: 'Videos',
    formats: 'MP4, MKV',
  },
  {
    category: 'Others',
    formats: 'ZIP, MP3, WAV',
  },
];

export const DEFAULT_DASHBOARD_VOLUME_TYPE = DashboardVolumeType.Net;

export const DASHBOARD_VOLUME_TYPE_LABEL: Record<DashboardVolumeType, string> =
  {
    [DashboardVolumeType.Cut]: 'Cut',
    [DashboardVolumeType.Fill]: 'Fill',
    [DashboardVolumeType.Net]: 'Net',
  };

export const VOLUME_TYPE_OPTIONS: SelectOption<DashboardVolumeType>[] = [
  DashboardVolumeType.Cut,
  DashboardVolumeType.Fill,
  DashboardVolumeType.Net,
].map((volumeType) => ({
  label: DASHBOARD_VOLUME_TYPE_LABEL[volumeType],
  value: volumeType,
}));

export const DEFAULT_VOLUME_TYPE_OPTION: SelectOption<DashboardVolumeType> = {
  label: DASHBOARD_VOLUME_TYPE_LABEL[DEFAULT_DASHBOARD_VOLUME_TYPE],
  value: DEFAULT_DASHBOARD_VOLUME_TYPE,
};
